import { memo, useEffect } from 'react'
import formModuleConnector from 'root/src/client/logic/form/connectors/formModuleConnector'
import withModuleContext from 'root/src/client/util/withModuleContext'
import dynamic from 'next/dynamic'
import { DynamicImportPlaceholder } from 'root/src/client/web/base/DynamicImportPlaceholder'

const BaseForm = dynamic(() => import('./BaseForm'), { loading: () => <DynamicImportPlaceholder /> })

export const FormModuleUnconnected = memo(({
	moduleId, moduleKey, formType, prePopulateForm, accountData, ...props
}) => {
	const formValues = JSON.stringify(props.prePopulateFormOn)

	useEffect(() => {
		if (!props.prePopulateFormOn) {
			return
		}
		prePopulateForm(moduleKey, { overwrite: false /* we only want to add few props instead clearing whole form */ })
	}, [formValues, accountData])

	const formProps = { moduleId, moduleKey, formType, ...props }
	switch (formType) {
	default:
		return <BaseForm {...formProps} />
	}
})

export default withModuleContext(
	formModuleConnector(FormModuleUnconnected),
)
